export type LocalizedString = {
    de?: string
    en?: string
}

export type TenantTreeNode = {
    _id: string
    sourceUuid: string
    describer: string
    name: LocalizedString
    fullName: LocalizedString
    parent: string | null
    isDepartment: boolean
    isDean: boolean
    isInfrastructure: boolean
    children: TenantTreeNode[]
}

export type TenantPerson = {
    _id: string
    given_name?: string
    family_name?: string
    email?: string
    preferred_username?: string
    esi?: string
}

export type TenantPersonAccess = {
    role: "facultyOwner" | "deputy" | "disabilityOfficer" | "reader"
    tenant: TenantTreeNode
    department: TenantTreeNode | null
}

export type TenantPersonSearchResult = {
    user: TenantPerson
    accesses: TenantPersonAccess[]
    memberships?: TenantTreeNode[]
}

export const getTenantLabel = (
    tenant: Pick<TenantTreeNode, "fullName" | "name" | "describer">
): string => {
    return tenant.fullName?.de ||
        tenant.name?.de ||
        tenant.describer
}
